export default __webpack_public_path__ + "media/erinVid.c1554151.mp4";